import { z } from 'zod'

export const visibilitySchema = z.enum(['PUBLIC', 'UNLISTED', 'PRIVATE'])

export const createProjectSchema = z.object({
  title: z.string().min(1, 'Title is required').max(200, 'Title must be 200 characters or fewer'),
  description: z
    .string()
    .max(10000, 'Description must be 10000 characters or fewer')
    .optional()
    .or(z.literal('')),
  visibility: visibilitySchema,
})

export type CreateProjectFormData = z.infer<typeof createProjectSchema>
